<template>
  <div class="coq-modal">
    <div class="coq-modal__top-right" v-if="!loading">
      <a @click="$emit('close')">
        <font-awesome-icon icon="times" type="fas" size="lg"/>
      </a>
    </div>

    <h3 style="text-align: center">Mot de passe oublié</h3>

    <!-- Payment in process -->

    <div style="text-align: center" v-if="success === true">
      <br />
      <p style="text-align: center">
        Un message a été transmis à votre adresse courriel avec un lien afin de modifier votre mot de passe.
      </p>
      <br />
    </div>

    <!-- Failed, needs Credit Card -->
    <div v-if="success !== true">
      <p>

        Veuillez entrer l'adresse courriel principale de votre compte COQ. Si vous éprouvez des difficultés à vous connecter ou à remplir la demande
        de réinitialisation de votre mot de passe, veuillez nous contacter au <a href="mailto:coq@coq.qc.ca">coq@coq.qc.ca</a> afin que nous puissions vous aider
      </p>

      <div style="text-align: center" v-if="error !== null">
        <p style="text-align: center; color: red">
          {{ error }}
        </p>
      </div>

      <br/>

      <b-form-group label="Adresse courriel">
        <b-form-input
            v-model="email"
            type="email"
            :state="validateState('email')"
            aria-describedby="input-email-feedback"
        />
        <b-form-invalid-feedback id="input-email-feedback">
          Veuillez entrer une adresse courriel valide
        </b-form-invalid-feedback>
      </b-form-group>

      <br />
      <br />
    </div>

    <div style="display: flex; flex-direction: row">
      <b-button variant="primary" style="width: 100%; margin-right: 5px;" @click="validateBeforeSubmit" v-if="success === false">
        <template v-if="loading">
          <font-awesome-icon icon="spinner" spin/>
        </template>
        <template v-else>
          Soumettre ma demande
        </template>
      </b-button>
      <b-button variant="danger" style="width: 100%; margin-left: 5px;" @click="$emit('close')" v-if="!loading">Fermer</b-button>
    </div>

    <br/>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  const { required, email } = require('vuelidate/lib/validators');

  export default {
    name: 'forgot-password-form',
    data() {
      return {
        success: false,
        email: null,
        loading: false,
        error: null
      };
    },
    validations: {
      email: {
        required,
        email
      }
    },
    methods: {
      ...mapActions('account', [ 'forgotPassword' ]),
      check() {
        this.$v.$touch();
        return !this.$v.$anyError;
      },
      validateState(name) {
        const { $dirty, $error } = this.$v[name];
        return $dirty ? !$error : null;
      },
      async validateBeforeSubmit() {
        this.loading = true;
        this.error = null;
        try {
          if (this.check() === true) {
            const response = await this.forgotPassword(this.email.trim());
            if (response === true) {
              this.success = true;
              this.loading = false;
            }
            else if (response === 'no-account') {
              this.error = 'Nous n\'avons pas trouvé de compte avec cet adresse courriel. Veuillez réessayer ou contacter le support technique.';
              this.loading = false;
            }
            else {
              this.error = response;
              this.loading = false;
            }
          }
        }
        finally {
          this.loading = false;
        }
      }
    }
  };
</script>

<style scoped>
  fieldset {
    padding: 0 !important;
  }
</style>
